import React from 'react';

const tagBaseClass =
  'inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium tabular-nums';

const tokenTagVariantClass: Record<'input' | 'output', string> = {
  input: 'border border-border bg-muted/80 text-muted-foreground',
  output: 'border border-primary/30 bg-primary/5 text-foreground',
};

interface U3204TokenTagProps {
  variant: 'input' | 'output';
  children: React.ReactNode;
  title?: string;
}

const U3204TokenTag: React.FC<U3204TokenTagProps> = ({ variant, children, title }) => (
  <span className={`${tagBaseClass} ${tokenTagVariantClass[variant]}`} title={title}>
    {children}
  </span>
);

export default U3204TokenTag;
